import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { DataWithGroupKey } from '../data-with-group-key';

@Component({
    selector: 'aa-item-popup-dropdown',
    templateUrl: './item-popup-dropdown.component.html',
    styleUrls: [
        './item-popup-dropdown.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ItemPopupDropdownComponent<T>
{
    @Input() item: DataWithGroupKey<T>;
    @Input() labelKey: keyof T;
    @Output() selectedItem: EventEmitter<T> = new EventEmitter<T>();

    public onClick (item: T): void
    {
        this.selectedItem.emit(item);
    }
}
